import { Component } from '@angular/core';

import { ShutdownDeviceBaseDirective } from './shutdown-device.base.directive';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ml-mdm-shutdown-device-dropdown-item',
  templateUrl: './shutdown-device-dropdown-item.component.html',
  imports: [NgbDropdownButtonItem, NgbDropdownItem],
})
export class ShutdownDeviceDropdownItemComponent extends ShutdownDeviceBaseDirective {}
